import { useSyncExternalStore } from 'react';

// The checklist drawer renders above the document preview overlay, so anything pinned to the
// preview's left edge (e.g. the previous-file button) needs to know how much of it is covered.
let inset = 0;
const listeners = new Set<() => void>();

export const setChecklistDrawerInset = (value: number) => {
  if (value === inset) return;
  inset = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => inset;

export const useChecklistDrawerInset = () => useSyncExternalStore(subscribe, getSnapshot);
